document.addEventListener('touchstart', function(event) {
			    var touch = event.touches[0]; 
			    if(touch.target.nodeType == 1){
			      finger_x0=touch.pageX;
			      finger_y0=touch.pageY;
			      //console.log("touchstart Touch x:" + touch.pageX + ", y:" + touch.pageY);
			    }else{
			      finger_x0=-1; 
			      finger_y0=-1; 
			    }
			  }, false);
document.addEventListener('touchmove', function(event) {
    var touch = event.touches[0];

  // On utilse window.graphCanvasDim pour voir si le finger est dans la zone du graphe
  //window.graphCanvasDim = {
  //  left:        rect.left + window.scrollX,
  //  right:       rect.right + window.scrollX,
  //  top:         rect.top + window.scrollY,
  //  bottom:      rect.bottom + window.scrollY,
  //};
  
    if(touch.pageX < window.graphCanvasDim.left || touch.pageX > window.graphCanvasDim.right){ //alert("HA ah");
	return;}
    if(touch.pageY < window.graphCanvasDim.top || touch.pageY > window.graphCanvasDim.bottom){ //alert("HA ah");
	return;}

    // Bloquer le scroll vertical dès qu'on est dans la zone du graphique
    event.preventDefault();
    suspendResizeListener();

    if(touch.target.nodeType == 1){
	finger_x=touch.pageX;
	finger_y=touch.pageY;
	// Note : le seuil permet de ne pas sauter en animation juste avec un
	//        petit balayage du doigt. Mais en mode anim, le seuil est plus
	//        petit pour aller vite
        let seuil=(window.graphCanvasDim.right-window.graphCanvasDim.left)*.1;
        if(finger_anim == 1 ){seuil=(window.graphCanvasDim.right-window.graphCanvasDim.left)*.03;}
	if(finger_x0-finger_x > seuil){
	    //console.log("avancer");
	    Set_Action('avancer');
	    finger_x0=finger_x;
	    finger_anim=1;
	}
	if(finger_x0-finger_x < -seuil){
	    //console.log("reculer");
	    Set_Action('reculer');
	    finger_x0=finger_x;
	    finger_anim=1;
	}
	//console.log("touchmove Touch x:" + touch.pageX + ", y:" + touch.pageY);
    }
    // Ne pas reprendre ici : le resize déclenché par le mouvement vertical
    // arriverait immédiatement après. La reprise se fait dans touchend.

}, { passive: false });

document.addEventListener('touchend', function(event) {
    if(Math.abs(finger_x0-finger_x) >= Math.abs(finger_y0-finger_y)){
	if(finger_x0 != -1 && finger_x !=-1 && finger_anim == 0){
	    //console.log("Balayage selon X");
	    //console.log("touchend finger_x0=" + finger_x0 + "finger_x=" + finger_x);
	    if( finger_x0-finger_x > 0 ){
		Set_Action('avancer');
	    }else{
		Set_Action('reculer');
		//console.log("touchend reculer");
	    }
	    finger_x0=-1;
	    finger_x=-1;
	}
	if(finger_anim == 1){finger_anim=0;}
    } else {
	if(local_zoom_y == 0){
	    local_zoom_y=1;
	}else{
	    local_zoom_y=0;
	}
        Set_Action('zoom_y');
	//console.log("Balayage selon Y, local_zoom_y="+local_zoom_y);
    }
    // Reprendre après un délai pour laisser passer les resize spurieux du geste
    setTimeout(resumeResizeListener, 300);
}, false);

function cre_cook(nom,contenu,jours) {
  var expireDate = new Date();
  expireDate.setTime(expireDate.getTime() + jours*24*3600*1000);
  document.cookie = nom + "=" + encodeURIComponent(contenu) + ";expires=" + expireDate.toUTCString() + ";path=/";

  // Expire un eventuel cookie residuel cree avant l'ajout de path=/ (path par defaut = repertoire courant),
  // qui sinon masque la valeur ci-dessus car plus specifique et donc liste en premier dans document.cookie
  document.cookie = nom + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
}

function lit_cook(nom) {
  var deb,fin;
  deb = document.cookie.indexOf(nom + "=");
  if (deb >= 0) {
    deb += nom.length + 1;
    fin = document.cookie.indexOf(";",deb);
    if (fin < 0) fin = document.cookie.length;
    return decodeURIComponent(document.cookie.substring(deb,fin));
  }
  return "";
}

function draw_wms_progress(pct) {
  var ctx = window.ctx_graph;
  if (!ctx) return;
  var w = window.gxsize;
  var h = window.gysize;

  ctx.fillStyle = '#f0f0f0';
  ctx.fillRect(0, 0, w, h);

  var barW = w * 0.7;
  var barH = Math.max(16, h * 0.07);
  var barX = (w - barW) / 2;
  var barY = (h - barH) / 2;

  ctx.fillStyle = '#cccccc';
  ctx.fillRect(barX, barY, barW, barH);

  ctx.fillStyle = '#3388ff';
  ctx.fillRect(barX, barY, barW * pct, barH);

  ctx.strokeStyle = '#555';
  ctx.lineWidth = 1;
  ctx.strokeRect(barX, barY, barW, barH);

  var fontSize = Math.max(12, h * 0.04);
  ctx.font = fontSize + 'px Arial';
  ctx.fillStyle = '#333';
  ctx.textAlign = 'center';
  ctx.textBaseline = 'bottom';
  // Effacer le conteneur des graphiques pour voir celui de la barre de téléchargement
  const conteneur = document.getElementById('graphiques');
  conteneur.innerHTML = '';
  ctx.fillText('Téléchargement des données du modèle à haute résolution ' + Math.round(pct * 100) + '%', w / 2, barY - 6);

  var newsFontSize = Math.max(10, h * 0.032);
  ctx.font = 'italic ' + newsFontSize + 'px Arial';
  ctx.fillStyle = '#3388ff';
  var newsY = barY + barH + newsFontSize * 1.6;
  ctx.fillText('Nouveau : données HRDPS à 2.5 km de résolution', w / 2, newsY);
  ctx.fillText('pour les prévisions de 0 à 48 heures.', w / 2, newsY + newsFontSize * 1.4);

  ctx.textAlign = 'start';
  ctx.textBaseline = 'alphabetic';
}

function set_canvas(message){
  if (ctx_graph){
    return ctx_graph;
  }else{
    alert('Probleme avec getContext sur Canvas dans '+message);
  }
}

function Set_Options() {
  window.open('./options.html') 
}

function Get_Info(item) {
  if(item == 'doc'){
    if(product == 'temp'){
      window.open('/imeteo/doc/temperature.html')
    } else if(product == 'vents'){
      window.open('/imeteo/doc/vent.html')
    } else if(product == 'profils'){
      ;
    } else if(product == 'roses'){
      window.open('/imeteo/doc/roses.html');
    } else if(product == 'sous_sol'){
      window.open('/imeteo/doc/sous_sol.html');
    } else if (product == 'precip') {
      window.open('/imeteo/doc/precip.html');
    } else if (product == 'nuages') {
      window.open('/imeteo/doc/nuages.html');  }else{
	alert("Le produit "+product+" n'est pas encore documente");
      }
  } else if (item == 'open_solar_redirection') {
    window.open('solar_redirection.html');
  }
}

